export const BANK_BRANCHES_ERSTE = {
	"Bács-Kiskun": {
		"Bajai Fiók (6500 Baja, Vörösmarty utca 5. )": "Bajai Fiók",
		"Kalocsai Fiók (6300 Kalocsa, Szent István király utca 37. )": "Kalocsai Fiók",
		"Kiskunhalasi Fiók (6400 Kiskunhalas, Bethlen Gábor tér 4.)": "Kiskunhalasi Fiók",
		"Kecskemét, Dobó körúti Fiók (6000 Kecskemét, Dobó körút 7.)": "Kecskemét, Dobó körúti Fiók",
		"Kecskemét, Kossuth téri Fiók (6000 Kecskemét, Kossuth tér 6-7.)": "Kecskemét, Kossuth téri Fiók",
		"Kiskunfélegyházi Fiók (6100 Kiskunfélegyháza, Mártírok útja 1.)": "Kiskunfélegyházi Fiók",
	},
	Baranya: {
		"Mohácsi Fiók (7700 Mohács, Szabadság út 16.)": "Mohácsi Fiók",
		"Pécs, Rákóczi úti Fiók (7620 Pécs, Rákóczi út 62-64.)": "Pécs, Rákóczi úti Fiók",
	},
	Békés: {
		"Békéscsaba, Andrássy úti Fiók (5600 Békéscsaba, Andrássy út 20.)": "Békéscsaba, Andrássy úti Fiók",
		"Szarvasi Fiók (5540 Szarvas, Szabadság utca 32. )": "Szarvasi Fiók",
	},
	"Borsod-Abaúj-Zemplén": {
		"Orosházi Fiók (5900 Orosháza, Kossuth utca 2-4.)": "Orosházi Fiók",
		"Kazincbarcikai Fiók (3700 Kazincbarcika, Egressy utca 44.)": "Kazincbarcikai Fiók",
		// NOTE: Miskolc Bajcsy-Zs u fiók átmenetileg elköltözött, egy másik fejlesztéssel pár hét múlva vissza kell majd állítani
		// 'Miskolc, Bajcsy-Zs. u. Fiók (3527 Miskolc, Bajcsy-Zsilinszky utca 1-3.)': 'Miskolc, Bajcsy-Zs. u. Fiók',
		"Miskolc, Zsigmondy Vilmos u. Fiók (3527 Miskolc, Zsigomndy Vilmos utca 2.)":
			"Miskolc, Zsigmondy Vilmos u. Fiók",
		"Miskolc, Corvin u. Fiók (3530 Miskolc, Corvin utca 1-3)": "Miskolc, Corvin u. Fiók",
		"Sárospataki Fiók (3950 Sárospatak, Rákóczi utca 40.)": "Sárospataki Fiók",
		"Tiszaújvárosi Fiók (3580 Tiszaújváros, Bethlen Gábor utca 5/b)": "Tiszaújvárosi Fiók",
	},
	"Budapest II. kerület": {
		"Hűvösvölgyi Fiók (1021 Budapest, Hűvösvölgyi út 138.)": "Hűvösvölgyi Fiók",
		"Mammut II., emeleti Fiók (1024 Budapest, Lövőház utca 1-5., 3. emelet)": "Mammut II., emeleti Fiók",
	},
	"Budapest III. kerület": {
		"Eurocenter Fiók (1032 Budapest, Bécsi út 154. (GoBuda))": "GoBuda Fiók",
		"Flórián téri Fiók (1033 Budapest, Flórián tér 3.)": "Flórián téri Fiók",
	},
	"Budapest IV. kerület": {
		"Újpesti Fiók (1042 Budapest, Árpád út 68.)": "Újpesti Fiók",
	},
	"Budapest V. kerület": {
		"Vörösmarty téri Fiók (1051 Budapest, Vörösmarty tér 4.)": "Vörösmarty téri Fiók",
	},
	"Budapest VI. kerület": {
		"Westend Fiók (1062 Budapest, Váci út 1-3.)": "Westend Fiók",
		"Teréz körúti Fiók (1066 Budapest, Teréz körút 24.)": "Teréz körúti Fiók",
	},
	"Budapest VIII. kerület": {
		"Corvin negyed Fiók (1085 Budapest, József körút 86.)": "Corvin negyed Fiók",
		"Kálvin téri Fiók (1082 Budapest, Baross utca 1-3.)": "Kálvin téri Fiók",
		"Aréna Pláza Fiók (1087 Budapest, Kerepesi út 9.)": "Aréna Pláza Fiók",
	},
	"Budapest X. kerület": {
		"Árkád Üzletközponti Fiók (1106 Budapest, Örs vezér tere 25.)": "Árkád Üzletközponti Fiók",
		"Kőbányai Fiók (1102 Budapest, Körösi Csoma sétány 9/B)": "Kőbányai Fiók",
	},
	"Budapest XI. kerület": {
		"Fehérvári út 130. Fiók (1116 Budapest, Fehérvári út 130.)": "Fehérvári út 130. Fiók",
		"Egry József utcai Fiók (1111 Budapest, Egry József utca 2.)": "Egry József utcai Fiók",
		"Bartók-Házi Fiók (1114 Budapest, Bartók Béla út 43-47.)": "Bartók-Házi Fiók",
		"Partner Centrum  (1117 Budapest, Október huszonharmadika utca 8-10.)": "Partner Centrum Fiók",
	},
	"Budapest XII. kerület": {
		"MOM Park Fiók (1123 Budapest, Alkotás utca 53.)": "MOM Park Fiók",
	},
	"Budapest XIII. kerület": {
		"Váci út 33. Fiók (1134 Budapest, Váci út 33.)": "Váci út 33. Fiók",
		"Európa Torony Fiók (1138 Budapest, Népfürdő utca 24-26.)": "Európa Torony Fiók",
	},
	"Budapest XIV. kerület": {
		"Thököly úti Fiók (1143 Budapest, Gizella út 59.)": "Thököly úti Fiók",
	},
	"Budapest XV. kerület": {
		"Pólus Irodaház Fiók (1152 Budapest, Szentmihályi út 137.)": "Pólus Irodaház Fiók",
	},
	"Budapest XVII. kerület": {
		"Rákoskeresztúri Fiók (1173 Budapest, Kaszáló utca 47.)": "Rákoskeresztúri Fiók",
	},
	"Budapest XIX. kerület": {
		"Kispesti Fiók (1193 Budapest, Kossuth tér 23-24.)": "Kispesti Fiók",
		"Köki Terminál Fiók (1195 Budapest, Vak Bottyán út 75. a-c.)": "Köki Terminál Fiók",
	},
	"Budapest XX. kerület": {
		"Pesterzsébeti Fiók (1203 Budapest, Kossuth Lajos utca 21-29.)": "Pesterzsébeti Fiók",
	},
	"Budapest XXI. kerület": {
		"Csepeli Fiók (1211 Budapest, Kossuth Lajos u. 82.)": "Csepeli",
	},
	"Budapest XXII. kerület": {
		"Campona Fiók (1222 Budapest, Nagytétényi út 37-43.)": "Campona Fiók",
	},
	Csongrád: {
		"Hódmezővásárhelyi Fiók (6800 Hódmezővásárhely, Andrássy út 2-4.)": "Hódmezővásárhelyi Fiók",
		"Makói Fiók (6900 Makó, Csanád Vezér tér 5.)": "Makói Fiók",
		"Szeged, Kölcsey u. Fiók (6720 Szeged, Kölcsey utca 13. )": "Szeged, Kölcsey u. Fiók",
		"Szeged, Széchenyi téri Fiók (6720 Szeged, Kölcsey utca 13.)": "Szeged, Széchenyi Kölcsey utcai Fiók",
		// NOTE:  Széchenyi téri fiók átmenetileg elköltözött, ezt egy másik fejlesztésben pár hét múlva vissza kell állítani A Széchenyi tér 7 címről
		// 'Szeged, Széchenyi téri Fiók (6720 Szeged, Széchenyi tér 17.)': 'Szeged, Széchenyi téri Fiók',
		"Szentesi Fiók (6600 Szentes, Kossuth u.12-16.)": "Szentesi Fiók",
	},
	Fejér: {
		"Dunaújvárosi Fiók (2400 Dunaújváros, Dózsa György utca 2/a.)": "Dunaújvárosi Fiók",
		"Székesfehérvár, Palotai úti Fiók (8000 Székesfehérvár, Palotai út 4.)": "Székesfehérvár, Palotai úti Fiók",
	},
	"Győr-Moson-Sopron": {
		"Csornai Fiók (9300 Csorna, Szent István tér 29.)": "Csornai Fiók",
		"Győr, Árpád úti Fiók (9021 Győr , Árpád út 42.)": "Győr, Árpád úti Fiók",
		"Mosonmagyaróvári Fiók (9200 Mosonmagyaróvár, Fő utca 26.)": "Mosonmagyaróvári Fiók",
		"Sopron, Előkapu Fiók (9400 Sopron, Előkapu 2-4.)": "Sopron, Előkapu Fiók",
	},
	"Hajdú-Bihar": {
		"Debrecen, Egyetemi Fiók (4032 Debrecen, Egyetem tér 1.)": "Debrecen, Egyetemi Fiók",
		"Debrecen, Vár u. Fiók (4024 Debrecen, Vár utca 4.)": "Debrecen, Vár u. Fiók",
		"Hajdúböszörményi Fiók (4220 Hajdúböszörmény, Szt. István tér 2. )": "Hajdúböszörményi Fiók",
		"Hajdúnánási Fiók (4080 Hajdúnánás, Dorogi utca 10-14.)": "Hajdúnánási Fiók",
		"Hajdúszoboszlói Fiók (4200 Hajdúszoboszló, Szilfákalja 49.)": "Hajdúszoboszlói Fiók",
	},
	Heves: {
		"Gyöngyösi Fiók (3200 Gyöngyös, Mikszáth Kálmán utca 4.)": "Gyöngyösi Fiók",
		"Egri Fiók (3300 Eger, Dobó tér 1.)": "Egri Fiók",
	},
	"Jász-Nagykun-Szolnok": {
		"Jászberényi Fiók (5100 Jászberény, Szabadság tér 20.)": "Jászberényi Fiók",
		"Karcagi Fiók (5300 Karcag, Kossuth tér 6.)": "Karcagi Fiók",
	},
	"Komárom-Esztergom": {
		"Esztergomi Fiók (2500 Esztergom, Petőfi Sándor utca 2.)": "Esztergomi Fiók",
		"Tatai Fiók (2890 Tata, Országgyülés tér 3.)": "Tatai Fiók",
		"Tatabányai Fiók (2800 Tatabánya, Fő tér 20.)": "Tatabányai Fiók",
	},
	Nógrád: {
		"Balassagyarmati Fiók (2660 Balassagyarmat, Rákóczi fejedelem utca 34-36.)": "Balassagyarmati Fiók",
		"Salgótarjáni Fiók (3100 Salgótarján, Erzsébet tér 5.)": "Salgótarjáni Fiók",
	},
	Pest: {
		"Budaörsi Fiók (2040 Budaörs, Szabadság u.27.)": "Budaörsi Fiók",
		"Dunaharaszti Fiók (2330 Dunaharaszti, Dózsa György út 27.)": "Dunaharaszti Fiók",
		"Érdi Fiók (2030 Érd, Budai út 13.)": "Érdi Fiók",
		"Százhalombattai Fiók (2440 Százhalombatta, Szent István tér 9.)": "Százhalombattai Fiók",
		"Szentendrei Fiók (2000 Szentendre, Duna korzó 18.)": "Szentendrei Fiók",
		"Szigetszentmiklós Auchan Fiók (2310 Szigetszentmiklós, Háros utca 120. (Auchan Áruház))":
			"Szigetszentmiklós Auchan Fiók",
		"Dunakeszi Fiók (2120 Dunakeszi, Fő út 24.)": "Dunakeszi Fiók",
		"Gödöllői Fiók (2100 Gödöllő, Szabadság tér 14.)": "Gödöllői Fiók",
		"Váci Fiók (2600 Vác, Széchenyi u. 14.)": "Váci Fiók",
	},
	Somogy: {
		"Kaposvári Fiók (7400 Kaposvár, Fő u.2.)": "Kaposvári Fiók",
		"Siófoki Fiók (8600 Siófok, Fő utca 172.)": "Siófoki Fiók",
	},
	"Szabolcs-Szatmár-Bereg": {
		"Komáromi Fiók (2900 Komárom, Gyár u. 2-6.)": "Komáromi Fiók",
		"Gyulai Fiók (5700 Gyula, Városház utca 16. )": "Gyulai Fiók",
		"Kisvárdai Fiók (4600 Kisvárda, Szent László utca 26.)": "Kisvárdai Fiók",
		"Mátészalkai Fiók (4700 Mátészalka, Kölcsey utca 15.)": "Mátészalkai Fiók",
		"Nyírbátori Fiók (4300 Nyírbátor, Szabadság tér 10)": "Nyírbátori Fiók",
		"Nyíregyháza, Korzó Fiók (4400 Nyíregyháza, Nagy Imre tér 1.)": "Nyíregyháza, Korzó Fiók",
		"Nyíregyháza, Országzászló téri Fiók (4400 Nyíregyháza, Országzászló tér 10.)":
			"Nyíregyháza, Országzászló téri Fiók",
		"Záhonyi Fiók (4625 Záhony, Ady Endre utca 27-31.)": "Záhonyi Fiók",
	},
	Tolna: {
		"Móri Fiók (8060 Mór, Köztársaság tér 1.)": "Móri Fiók",
		"Paksi Fiók (7030 Paks, Dózsa György út 64.)": "Paksi Fiók",
		"Szekszárdi Fiók (7100 Szekszárd, Széchenyi utca 40.)": "Szekszárdi Fiók",
		"Dombóvári Fiók (7200 Dombóvár, Hunyadi tér 19-21.)": "Dombóvári Fiók",
	},
	Vas: {
		"Sárvári Fiók (9600 Sárvár, Batthyány u. 20.)": "Sárvári Fiók",
		"Szentgotthárdi Fiók (9970 Szentgotthárd, Széchenyi utca 2.)": "Szentgotthárdi Fiók",
		"Szombathely, Mártírok tér Fiók (9700 Szombathely, Mártírok tere 12.)": "Szombathely, Mártírok tér Fiók",
	},
	Veszprém: {
		"Ajkai Fiók (8400 Ajka , Szabadság tér 4/a.)": "Ajkai Fiók",
		"Pápai Fiók (8500 Pápa, Fő tér 25-26.)": "Pápai Fiók",
		"Várpalotai Fiók (8100 Várpalota, Szent István út 7-9.)": "Várpalotai Fiók",
		"Veszprém, Ádám Iván utcai Fiók (8200 Veszprém, Ádám Iván utca 2.)": "Veszprém, Ádám Iván utcai Fiók",
		"Szolnok, Baross u. Fiók (5000 Szolnok, Baross utca 8.)": "Szolnok, Baross u. Fiók",
		"Törökszentmiklósi Fiók (5200 Törökszentmiklós, Kossuth utca 125.)": "Törökszentmiklósi Fiók",
	},
	Zala: {
		"Keszthelyi Fiók (8360 Keszthely , Kossuth utca 11.)": "Keszthelyi Fiók",
		"Nagykanizsa, Belvárosi Fiók (8800 Nagykanizsa, Fő utca 2.)": "Nagykanizsa, Belvárosi Fiók",
		"Zalaegerszeg,Ispotályközi Fiók (8900 Zalaegerszeg, Ispotály köz 2.)": "Zalaegerszeg,Ispotályközi Fiók",
	},
};
